import * as actions from "./types";

export function toggleSidebar(bool) {
  return {
    type: actions.TOGGLE_SIDEBAR,
    payload: bool
  };
}



// WEBPACK FOOTER //
// ./src/system/store/site/actions.js